import React, { useState, useEffect } from 'react';
import JBrowseService from '../services/jbrowse.service';
import { Widget, addResponseMessage, toggleWidget } from 'react-chat-widget';
import _ from 'underscore';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Button,
  Typography,
  TextField,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const LiteratureModal = (props) => {
    // console.log("props: ", props );
    const {
        literatureSearch,
        setLiteratureSearch,
        literatureModalIsOpen,
        setLiteratureModalIsOpen,
        setLoading,
        currentUser,
        literaturePrompt,
        setLiteraturePrompt,
        selectedCrop,
        conversation,
        isWidgetOpen,
        setLiteratureSearchError,
        setShowToolsModal,
    } = props;

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                closeModal();
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        // Cleanup the event listener when the component is unmounted
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const [filter, setFilter] = useState('');
    const [filteredResults, setFilteredResults] = useState(literatureSearch);
    const [spinner, setSpinner ] = useState( false );

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                closeModal();
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    useEffect(() => {
        const updatedResults = literatureSearch.map(item => ({
            ...item,
            title: item.title.replace(/\[(HTML|PDF)\]/g, '') // Removes all instances of [HTML] and [PDF]
        }));

        setFilteredResults(updatedResults.filter(item =>
            item.title.toLowerCase().includes(filter.toLowerCase())
        ));
    }, [filter, literatureSearch]);

    const closeModal = () => {
        setLiteratureModalIsOpen(false);
    };

    const handleGoBack = () => {
        setLiteratureModalIsOpen(false);
        setShowToolsModal(true);
    };

    const handleNewSearch = () => {
        console.log("literaturePrompt: ", literaturePrompt);
        setSpinner(true);
        let obj = {
            user: currentUser.email,
            prompt: literaturePrompt,
            crop: selectedCrop
        };
        console.log("obj: ", obj);
        // Send Request
        JBrowseService.scholarSearch(obj).then(
            (response) => {
                console.log("scholor response: ", response);
                setLiteratureSearch(response.result);
                setSpinner(false);
            },
            (error) => {
                console.log("google error: ", error);
                setSpinner(false);
            }
        );
    };

    const handleAiSearch = () => {
        setSpinner(true);
        let message = findLastAssistantContent(conversation);
        let obj = {
            message: message,
            user: currentUser.email,
            crop: selectedCrop
        };
        console.log("obj: ", obj);
        if (obj.message === null) {
            console.warn("this wont work..");
            setSpinner(false);
            return;
        }
        // Send Request 
        JBrowseService.literatureSearch(obj).then(
            (response) => {
                console.log("literature serach response: ", response);
                if (response.result.articles.length === 0) {
                    setLiteraturePrompt(response.result.prompt);
                    setLiteratureSearchError(true);
                    setTimeout(() => {
                        setLiteratureSearchError(false);
                    }, 5000);
                    setSpinner(false);
                } else {
                    setLiteraturePrompt(response.result.prompt);
                    setLiteratureSearch(response.result.articles);
                    setSpinner(false);
                }
            },
            (error) => {
                console.log("error: ", error);
                setLiteratureSearchError(true);
                setTimeout(() => {
                    setLiteratureSearchError(false);
                }, 3000);
                setSpinner(false);
            }
        );
    };

    return (
        <Dialog
            open={literatureModalIsOpen}
            onClose={closeModal}
            fullWidth
            maxWidth="lg"
            PaperProps={{
                style: {
                    boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.16)',
                },
            }}
        >
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6">Literature Search</Typography>
                <IconButton onClick={closeModal}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 2, mb: 2 }}>
                    <TextField
                        multiline
                        minRows={2}
                        maxRows={4}
                        fullWidth
                        variant="outlined"
                        value={literaturePrompt}
                        onChange={(e) => setLiteraturePrompt(e.target.value)}
                        placeholder="Enter new literature search prompt"
                        sx={{
                            fontFamily: 'Arial',
                        }}
                    />
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleNewSearch}
                    >
                        Search
                    </Button>
                </Box>

                {spinner && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                        <div className="lds-ellipsis">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                        <Typography
                            variant="body1"
                            color="text.secondary"
                            sx={{ fontStyle: 'italic' }}
                        >
                            Awaiting response from Google scholar...
                        </Typography>
                    </div>
                )}

                {filteredResults.length > 0 ? (
                    <>
                        <TextField
                            type="text"
                            variant="outlined"
                            value={filter}
                            onChange={(e) => setFilter(e.target.value)}
                            placeholder="Search Papers..."
                            sx={{ mb: 2 }}
                            fullWidth
                        />
                        <ul style={{ paddingInlineStart: '20px', marginTop: '8px' }}>
                            {filteredResults.map((item, index) => (
                                <li key={index} style={{ marginTop: index === 0 ? 0 : '16px' }}>
                                    <a
                                        href={item.title_link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{
                                            color: '#1976d2',
                                            textDecoration: 'none',
                                            fontWeight: 600
                                        }}
                                    >
                                        {item.title}
                                    </a>
                                    <p style={{ color: '#4b5563', marginTop: '4px' }}>
                                        {item.publication_info}
                                    </p>
                                    <small style={{ color: '#6b7280' }}>
                                        {item.snippet}
                                    </small>
                                </li>
                            ))}
                        </ul>
                    </>
                ) : (
                    <Typography sx={{ color: '#4b5563', mt: 1 }}>
                        No results were found for this search.
                    </Typography>
                )}
            </DialogContent>

            <DialogActions sx={{ justifyContent: 'space-between' }}>
                {/* Left-aligned button */}
                <Button
                    variant="contained"
                    onClick={handleGoBack}
                    sx={{ bgcolor: 'grey.400', '&:hover': { bgcolor: 'grey.500' } }}
                >
                    Go Back
                </Button>

                {/* Right-aligned button group */}
                <Box sx={{ display: 'flex', gap: 1 }}>
                    {conversation.length > 0 && (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleAiSearch}
                        >
                            Search AI Conversation
                        </Button>
                    )}
                    <Button
                        variant="contained"
                        onClick={closeModal}
                        sx={{ bgcolor: 'grey.400', '&:hover': { bgcolor: 'grey.500' } }}
                    >
                        Close
                    </Button>
                </Box>
            </DialogActions>

        </Dialog>
    );
};

export default LiteratureModal;

function findLastAssistantContent(array) {
    for (let i = array.length - 1; i >= 0; i--) {
        if (array[i].role === "assistant") {
            return array[i].content;
        }
    }
    return null; // Return null or any other value if not found
}
